import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteUserDialogContentComponent } from './delete-user-dialog-content/delete-user-dialog-content.component';

@Component({
  selector: 'app-delete-user-dialog',
  template: ''
})
export class DeleteUserDialogComponent implements OnInit {

  private userId: string;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.userId = params.get('key');
      this.openDialog();
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DeleteUserDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.userId = this.userId;

    dialogRef.result.then((result) => {
      this.router.navigate(['manage/users']);
    }, (backdrop) => {
        this.router.navigate(['manage/users']);
    });
  }

}
